import http from "../http";

export async function getContractTerms(config) {
  const response = await http.get(`/contract-terms`, config);
  return response.data;
}

export async function updateContractTerms(config) {
  const response = await http.post(`/contract-terms`, config);
  return response.data;
}
